import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';
import getFormattedValues from 'utils/formatValues';

export const baseURI = 'nominas/historico-incapacidades';

const getValuesAndConfig = (values) => {
  const config = {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  };
  const formattedValues = getFormattedValues(values, {
    formData: config.headers,
    clean: false,
  });
  return [formattedValues, config];
};

/**
 * GET Historicos Incapacidades
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getHistoricosIncapacidades = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Historico Incapacidad
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getHistoricoIncapacidad = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Historico Incapacidad
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postHistoricoIncapacidad = async (values) => {
  try {
    const response = await API.post(baseURI, ...getValuesAndConfig(values));
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
  }
  return false;
};

/**
 * PATCH Historico Incapacidad
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchHistoricoIncapacidad = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, ...getValuesAndConfig(values));
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
  }
  return false;
};

/**
 * DELETE Historico Incapacidad
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteHistoricoIncapacidad = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
  }
  return false;
};
